import { render, staticRenderFns } from "./jt808-monitoring-view-modal.vue?vue&type=template&id=5bdade8d&scoped=true&"
import script from "./jt808-monitoring-view-modal.vue?vue&type=script&lang=js&"
export * from "./jt808-monitoring-view-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdade8d",
  null
  
)

export default component.exports